/*
	Komponenta, kerá kontroluje, jestli je uživatel přihlášen.
*/

import React from 'react';
import { withRouter } from 'react-router-dom';
import { Query} from 'react-apollo';
import gql from 'graphql-tag';

const withAuthentication = (Component) => {
  class withAuthentication extends React.Component {
    
	render() {

		const {history} = this.props;
		const IS_LOGGED_IN = gql`
			query IsUserLoggedIn {
				isLoggedIn @client
				loginPlace @client
			}
		`;

		const Redirect = () => {
			setTimeout(() => {
				history.push("/");
			},250);
		}

		return (

			//načítá se isLoggedIn z cache apolla
			<Query query={IS_LOGGED_IN}>
				
				{({data,loading,errro}) => {

					if(data && data.isLoggedIn && data.loginPlace == "3fdc94bf1dd7dccf3d202a768df0a1eb")return(<Component {...this.props} />);
					else {Redirect(); return "";}

				}}

			</Query>

		);
    }
  }

  return withRouter(withAuthentication);
  
}

export default withAuthentication;